import React from "react";
import Reveal from "./Reveal";

export default function About() {
  return (
    <section id="about" className="bg-white py-24 md:py-36 border-t border-[var(--line)]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          {/* Left — heading */}
          <Reveal className="md:col-span-5 md:sticky md:top-24 md:self-start">
            <span className="text-[12px] sans tracking-luxe text-[#111]/75">
              Our story
            </span>
            <h2 className="serif text-[40px] sm:text-[52px] md:text-[60px] leading-[1.05] mt-4 text-[#111] font-light">
              From Warner Beach,
              <br />
              <span className="italic">to London.</span>
            </h2>
            <p className="mt-6 sans text-[15px] leading-[1.85] text-[#111]/75 max-w-[420px]">
              A South African beginning, a London imagination, and one dress that
              carries both.
            </p>
          </Reveal>

          {/* Right — story */}
          <Reveal className="md:col-span-6 md:col-start-7" delay={120}>
            <p className="serif text-[22px] sm:text-[24px] md:text-[26px] leading-[1.55] text-[#111]/95">
              Rapallini is born from a lifelong passion for effortless,
              affordable style.
            </p>

            <p className="mt-6 sans text-[16px] leading-[1.9] text-[#111]/85 max-w-[560px]">
              Founded by <span className="serif italic">Chanel Rapallini</span>,
              whose journey began on the shores of Warner Beach in South Africa
              and has been refined by two decades of living and designing in
              London. The house reflects a truly international perspective on
              fashion, equal parts coastal ease and London polish.
            </p>

            <p className="mt-6 sans text-[16px] leading-[1.9] text-[#111]/85 max-w-[560px]">
              We champion the joy of simple, stress free dressing that sparks
              joy every time you wear it. That&apos;s why we dedicated ourselves
              to creating the <span className="serif italic">Magic Dress</span>:
              one piece designed to solve every wardrobe challenge, effortlessly
              transforming into over six distinct looks.
            </p>

            <p className="mt-6 sans text-[16px] leading-[1.9] text-[#111]/85 max-w-[560px]">
              Our signature fabric is a testament to this philosophy. We chose
              a viscose knit, also known as rayon, because it strikes the
              perfect balance. It is buttery soft against the skin with a
              fluid, luxurious drape, yet accessible enough to become an
              everyday favourite.
            </p>

            {/* Feature pill row */}
            <div className="mt-10 flex flex-wrap gap-2.5 max-w-[560px]">
              {[
                "Viscose knit",
                "Six silhouettes",
                "XXS to XXL",
                "Maternity friendly",
                "Designed in London",
                "Made by hand",
              ].map((tag) => (
                <span
                  key={tag}
                  className="inline-block text-[11px] sans tracking-luxe text-[#111]/85 border border-[var(--line)] rounded-full px-4 py-2"
                >
                  {tag}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
